// src/store/reducers/index.js
import { combineReducers } from "redux";
import UserReducer from "./userReducer";
import CopyReducer from "./copyReducer"; // Assuming you have a copyReducer
import ShiftReducer from "./shiftReducer";
import TimeReducer from "./timeReducer";

const rootReducer = combineReducers({
  user: UserReducer,
  copy: CopyReducer,
  shift: ShiftReducer, // Assuming you have a shiftReducer
  time: TimeReducer,
});

export default rootReducer;
